import z from "zod";

export const mmRequestTabsSearchSchema = z.object({
  tab: z
    .enum(["details", "materialList", "attachments", "comments", "history"])
    .default("details")
    .catch("details"),
});

export type MmRequestTabsSearch = z.infer<typeof mmRequestTabsSearchSchema>;
